import { queryOptions, useQuery } from '@tanstack/react-query';

import { getActiveFlashes, getAllFlashes, getFlashById } from '@/lib/api/flash';

import { queryKeys } from './query-keys-factory';

/**
 * Query Options Factories
 */
export const flashQueries = {
  /**
   * Get all flash messages
   */
  all: () =>
    queryOptions({
      queryKey: queryKeys.flashes.list(),
      queryFn: getAllFlashes,
      staleTime: 1000 * 60 * 5, // 5 minutes (flash messages change more frequently)
      retry: false,
    }),

  /**
   * Get currently active flash messages
   */
  active: () =>
    queryOptions({
      queryKey: queryKeys.flashes.list({ active: true }),
      queryFn: getActiveFlashes,
      staleTime: 1000 * 60 * 5,
      retry: false,
    }),

  /**
   * Get flash by ID
   */
  byId: (id: string) =>
    queryOptions({
      queryKey: queryKeys.flashes.detail(id),
      queryFn: () => getFlashById(id),
      staleTime: 1000 * 60 * 5,
      enabled: !!id,
      retry: false,
    }),
};

/**
 * Query Hooks
 */

/**
 * Hook to fetch all flash messages
 */
export const useGetAllFlashes = () => useQuery(flashQueries.all());

/**
 * Hook to fetch currently active flash messages
 */
export const useGetActiveFlashes = () => useQuery(flashQueries.active());

/**
 * Hook to fetch flash by ID
 */
export const useGetFlashById = (id: string) => useQuery(flashQueries.byId(id));
